<layout-container>
  <div class="welcome-screen-headers flex flex-col flex-start-center gap-36">
    <h1>Welcome to my7N!</h1>
    <h4>
      Here you can create your CV. Remember that the more effort you put into your CV preparation the better job
      conditions we are likely to negotiate for you.
    </h4>
  </div>
  <div class="welcome-content-video-container">
    <mat-card appearance="outlined" class="welcome-content">
      <div
        [ngStyle]="{ height: videoPlayerConfig.containerHeight + 'px' }"
        #welcomeContentVideo
        class="welcome-content-video"
      >
        @if (!showVideo) {
          <div class="welcome-content-video-plug"></div>
        }
        @if (!watchedVideo && !showVideo) {
          <button (click)="show()" class="introduction-button" color="primary" mat-stroked-button>
            Watch introduction
          </button>
        }
        @if (watchedVideo && !showVideo) {
          <button (click)="letMeIn()" class="create-cv-button" color="accent" mat-flat-button>Create new CV</button>
        }
        @if (showVideo) {
          <my7n-video-player
            [config]="videoPlayerConfig"
            [module]="LogVideoModules.Welcome"
            (videoEvent)="onVideoPlayerEvent($event)"
            articleId="my7n-welcome-video"
            title="my7N Welcome Video"
            videoUrl="https://player.vimeo.com/video/400226605"
          ></my7n-video-player>
        }
      </div>
    </mat-card>
  </div>
  <div class="welcome-screen-actions flex flex-center-center">
    <button
      [disableRipple]="true"
      (click)="letMeIn()"
      class="button-hidden-icon"
      color="primary"
      isIconButton="true"
      mat-button
    >
      Skip introduction and create new CV
      <mat-icon svgIcon="arrow_right"></mat-icon>
    </button>
  </div>
</layout-container>
